<div>
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>👍 White-Listed Accounts (Personal)</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngIf="isLoading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <ng-container *ngIf="!isLoading && whiteListedBankAccounts">
        <mat-table [dataSource]="whiteListedBankAccounts">
          <ng-container matColumnDef="createDate">
            <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
            <mat-cell *matCellDef="let ba"> {{ ba.createdDate | date : 'dd.MM.yyyy HH:mm' }}  </mat-cell>
          </ng-container>
          <ng-container matColumnDef="senderAccountName">
            <mat-header-cell *matHeaderCellDef>Sender</mat-header-cell>
            <mat-cell *matCellDef="let ba"> {{ba.senderAccountName}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="senderAccountNumber">
            <mat-header-cell *matHeaderCellDef>Account</mat-header-cell>
            <mat-cell *matCellDef="let ba"> {{ba.senderAccountNumber}} </mat-cell>
          </ng-container>

          <!-- Header and Row Declarations -->
          <mat-header-row *matHeaderRowDef="['createDate', 'senderAccountName', 'senderAccountNumber']"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['createDate', 'senderAccountName', 'senderAccountNumber']"></mat-row>
        </mat-table>

      </ng-container>
      <div class="text-center mt-1 mb-1 w-100" *ngIf="!isLoading && (!whiteListedBankAccounts || whiteListedBankAccounts.length == 0)">
        <i>- none- </i>
      </div>
    </mat-card-content>
  </mat-card>
</div>
